import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

import { cn } from '../../../../utils/cn';

export const MessageMarkdown = ({ isUser, children }: { isUser: boolean; children: string }) => {
  return (
    <ReactMarkdown
      remarkPlugins={[remarkGfm]}
      components={{
        a: ({ node, ...props }) => (
          <a
            {...props}
            target="_blank"
            rel="noopener noreferrer"
            className={cn(
              'underline transition-opacity duration-300 hover:opacity-70',
              isUser ? 'text-white' : 'text-brand-blue',
            )}
          />
        ),
        img: ({ node, ...props }) => (
          <img
            {...props}
            className="my-2 max-w-[392px] min-w-[200px] h-auto block"
            loading="lazy"
          />
        ),
        p: ({ node, ...props }) => <p {...props} className="mb-2.5 last:mb-0 leading-7" />,
        ul: ({ node, ...props }) => <ul {...props} className="mb-2.5 list-disc pl-5 space-y-1.5" />,
        ol: ({ node, ...props }) => (
          <ol {...props} className="mb-2.5 list-decimal pl-5 space-y-1.5" />
        ),
        li: ({ node, ...props }) => <li {...props} className="pl-1" />,
        strong: ({ node, ...props }) => <strong {...props} className="font-medium" />,
        code: ({ node, ...props }) => (
          <code {...props} className="bg-black/10 px-1 py-0.5 font-mono text-xs" />
        ),
        pre: ({ node, ...props }) => (
          <pre {...props} className="overflow-x-auto bg-black/10 p-3 text-xs" />
        ),
      }}
    >
      {children}
    </ReactMarkdown>
  );
};
